import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  getCategoriesMock,
  scormDetailsGetMock,
  scormListGetMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { scormPath } from '../../utils/paths';

export default {
  scormCategoriesGet: () => {
    if (shouldUseMock()) {
      return getCategoriesMock();
    }
    return apiCall(`${baseUrl}${scormPath}category/list`, 'GET');
  },
  scormListGet: (filters) => {
    if (shouldUseMock()) {
      return scormListGetMock();
    }
    return apiCall(
      `${baseUrl}${scormPath}scorms/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  scormDetailsGet: (id) => {
    if (shouldUseMock()) {
      return scormDetailsGetMock();
    }
    return apiCall(`${baseUrl}${scormPath}scorm/${id}/preview`, 'GET');
  },
};
